import globalHeroBackground from "@/assets/global-hero-bg.svg";

export function GlobalHeroBackground() {
  return (
    <div className="pointer-events-none absolute inset-x-0 top-0 -z-[1] flex justify-center overflow-clip" aria-hidden="true">
      <img
        src={globalHeroBackground}
        alt=""
        className="block h-auto w-[min(100vw,90rem)] max-w-none flex-none max-[991px]:w-[130vw] max-[767px]:w-[180vw] max-[479px]:w-[290vw]"
      />
    </div>
  );
}
